module.exports = __webpack_public_path__ + "img/edit-not-approved.67a7bd3b.svg";